import Tag from './Tag';

export default Tag;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/tag/index.js
// module id = 75
// module chunks = 0